<template>
    <div>
        <div class="title">
            <typo name="body-17-bold"> Indemnité </typo>
        </div>
        <search-panorama-value-comparison
            label="Ancienneté minimum"
            v-model="indemnityFilters.minimumSeniority"
            :annotationOptions="annotationOptions"
        />
        <search-panorama-value-comparison
            label="Plafond"
            v-model="indemnityFilters.ceiling"
            :annotationOptions="annotationOptions"
        />
        <search-panorama-value-comparison
            label="Planché"
            v-model="indemnityFilters.floor"
            :annotationOptions="annotationOptions"
        />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import Typo from "src/components/common/typo/Typo.vue";
import SearchPanoramaValueComparison from "./SearchPanoramaValueComparison.vue";

export default {
    props: ["value", "annotationOptions"],
    components: {
        Typo,
        SearchPanoramaValueComparison,
    },
    data() {
        return {
            indemnityFilters: {
                minimumSeniority: this.value.minimumSeniority,
                ceiling: this.value.ceiling,
                floor: this.value.floor,
            },
        };
    },
    mounted() {
        EventBus.$on("clearPanoramaFilters", () => {
            this.indemnityFilters = {
                minimumSeniority: null,
                ceiling: null,
                floor: null,
            };
        });
    },
    watch: {
        indemnityFilters: {
            handler(_indemnityFilters) {
                this.$emit("input", _indemnityFilters);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass">
.title
    margin: 16px 0

.rates-container
    display: flex
    height: 35px
</style>
